import { Component } from '@angular/core';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { EnumWindowSizes } from '@core/framework/sysenums.enum';
import { NotificationGridComponent } from '../notificationgrid.component';

@Component({
    providers: ServiceBagServices,
    selector: 'app-email-history-grid',
    templateUrl: './email-history-grid.component.html',
    styleUrls: ['./email-history-grid.component.scss']
})
export class EmailHistoryGridComponent extends NotificationGridComponent {
    
    constructor(A: ServiceBagService) {
        super(A, 'EmailHistoryGridComponent');
    }

    override OnNavigate(e) {
        this.Navigate(["/pages/general/notificationview", e.data.EntryID], { WindowWidth: EnumWindowSizes.WindowLarge });
    }
}